import * as XLSX from "xlsx";

/**
 * Converts an array of objects to an Excel workbook and triggers a browser download.
 * @param {string} filename - The name of the downloaded file (without extension).
 * @param {Object[]} rows - Array of objects representing table rows.
 * @param {Array<{key: string, label: string}>} columns - Column definitions.
 */
export function downloadCSV(filename, rows, columns) {
  if (!rows || rows.length === 0) return;

  const data = [
    columns.map((c) => c.label),
    ...rows.map((row) =>
      columns.map((c) => {
        const v = row[c.key];
        return v === null || v === undefined ? "" : v;
      })
    ),
  ];

  const ws = XLSX.utils.aoa_to_sheet(data);

  // Auto-width for columns
  ws["!cols"] = columns.map((c) => ({
    wch: Math.max(c.label.length, 12),
  }));

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Export");
  XLSX.writeFile(wb, `${filename}.xlsx`);
}
